/* eslint-disable no-unused-vars */
import SelectLogoContent from '@/components/Onboarding/SelectLogoContent';
import { COUNTRY_CODES } from '@/const/countries.constants';
import {
    Button,
    Divider,
    Form,
    notification,
    PageHeader,
    Space,
    Typography,
} from 'antd';
import { get } from 'lodash';
import { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FaLightbulb } from 'react-icons/fa';
import { updateSmallFleet } from '../../../api/small-fleet.api';
import { useWorkspaceStore } from '../../../store/workspace.store';
import { generateDataToUpdate } from '../utils/account';

const { Title, Text } = Typography;

const ManageLogo: FC = () => {
    const { t } = useTranslation('settings', { keyPrefix: 'SETTINGS' });

    const workspace = useWorkspaceStore((state) => state.data);
    const [defaultLogo, setDefaultLogo] = useState<null | string>('');
    const [isLogoUploaded, setLogoUploaded] = useState<null | string>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    const onSubmit = async () => {
        setLoading(true);

        const values = form.getFieldsValue();

        const dataToUpdate = await generateDataToUpdate({
            formValues: {
                countryCodeName: COUNTRY_CODES[workspace?.country as keyof typeof COUNTRY_CODES],
                logo: values.logo,
            },
            activeWorkspace: workspace,
            defaultLogo,
            isLogoUploaded,
            setLogoUploaded,
        });

        const fleetId = workspace?._id || '';

        updateSmallFleet(fleetId, dataToUpdate)
            .then(() => {
                notification.success({
                    message: t('GENERAL.DATA_UPDATED_SUCCESS'),
                });
            })
            .catch((error) => {
                const description = get(error, 'response.data.message', t('GENERAL.DATA_UPDATED_ERROR'));
                notification.error({
                    message: 'Error',
                    description,
                });
            })
            .finally(() => setLoading(false));
    };

    return (
        <PageHeader
            title={(
                <Title level={5} style={{ marginBottom: 0 }}>
                    {t('GENERAL.BRANDING_CONFIG')}
                </Title>
            )}
            extra={(
                <Button
                    type="primary"
                    size="small"
                    loading={loading}
                    onClick={() => onSubmit()}
                >
                    {t('ACTIONS.SAVE')}
                </Button>
            )}
            footer={(
                <div
                    style={{
                        borderRadius: 8,
                        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08)',
                        padding: '16px 24px',
                    }}
                >
                    <Space direction="vertical" size={16}>
                        <Form form={form} layout="vertical" style={{ width: '100%' }}>
                            <SelectLogoContent setDefaultLogo={setDefaultLogo} />
                        </Form>
                    </Space>

                    <Divider style={{ margin: '16px 0' }} />

                    <Space size={8}>
                        <FaLightbulb size={16} style={{ verticalAlign: 'middle' }} />
                        <Text>
                            <Trans
                                t={t}
                                i18nKey="GENERAL.BRANDING_HELP"
                                components={{ b: <b /> }}
                            />
                        </Text>
                    </Space>
                </div>
            )}
        />

    );
};

export { ManageLogo };
